/* ============================================================
   StatsFooter — 공통 푸터 (모든 view 공통, 2026-05-12 격상)
   2026-05-13 App.tsx 분리
   ============================================================ */
import type { SchemaStats } from '../../useStats'

interface StatsFooterProps {
  stats: SchemaStats
}

export function StatsFooter({ stats }: StatsFooterProps) {
  return (
    <div className="stats-footer">
      <div className="stat-item">
        <span className="label">Schemas</span>
        <span className="value">{stats.ready ? stats.schemas || '—' : '—'}</span>
      </div>
      <div className="stat-item">
        <span className="label">Tables</span>
        <span className="value">{stats.ready ? stats.tables || '—' : '—'}</span>
      </div>
      <div className="stat-item">
        <span className="label">Views</span>
        <span className="value">{stats.ready ? stats.views || '—' : '—'}</span>
      </div>
      <div className="stat-item">
        <span className="label">Total Rows</span>
        <span className="value">{stats.ready ? stats.rows.toLocaleString() : '—'}</span>
      </div>
      <span className="ts">
        {stats.ready
          ? (stats.error ? `data unavailable (${stats.error})` : 'live')
          : 'loading...'} · BOARD v2 · React
      </span>
    </div>
  )
}
